import React from 'react';

// GR apparatus icons — custom SVGs sized to 32x32, use currentColor
export const BallIcon = ({ size = 32, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...p}>
    <circle cx="12" cy="12" r="9" />
  </svg>
);

export const HoopIcon = ({ size = 32, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" {...p}>
    <circle cx="12" cy="12" r="8.5" />
  </svg>
);

// Ribbon: GR "ruban" — thin stick + ribbon forming two clear open loops (real GR ribbon style)
export const RibbonIcon = ({ size = 32, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    {/* thin stick from bottom-right going up-left */}
    <line x1="28" y1="29" x2="22" y2="22" />
    {/* ribbon: exits stick tip, makes 2 open loops going up-left */}
    <path d="M22 22
             C 27 22 27 29 20 28
             C 13 27 13 20 20 20
             C 27 20 27 11 19 11
             C 11 11 6 18 12 22
             C 15 24 17 22 15 19" />
  </svg>
);

// Rope: a curved line with small solid knots (balls) at each end
export const RopeIcon = ({ size = 32, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...p}>
    <path d="M4 8 C 8 8, 8 16, 12 16 S 16 8, 20 8" />
    <circle cx="4" cy="8" r="2" fill="currentColor" stroke="none" />
    <circle cx="20" cy="8" r="2" fill="currentColor" stroke="none" />
  </svg>
);

// Clubs: GR "massues" — two slim elongated clubs (small head + long thin body + rounded base)
export const ClubsIcon = ({ size = 32, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...p}>
    {/* left club */}
    <g transform="translate(4.5, 0)">
      <circle cx="0" cy="3" r="1.6" />
      <path d="M-0.9 4.3 L -0.6 19 C -0.55 20.3 0.55 20.3 0.6 19 L 0.9 4.3 Z" />
      <ellipse cx="0" cy="20.2" rx="1.15" ry="1" />
    </g>
    {/* right club */}
    <g transform="translate(15.5, 0)">
      <circle cx="0" cy="3" r="1.6" />
      <path d="M-0.9 4.3 L -0.6 19 C -0.55 20.3 0.55 20.3 0.6 19 L 0.9 4.3 Z" />
      <ellipse cx="0" cy="20.2" rx="1.15" ry="1" />
    </g>
  </svg>
);
